module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_306144.2a88d511.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSat/FormatoSimplificado_306144.pdf
// module id = 819
// module chunks = 0